import { useQuery } from 'react-query';
import { useHistory } from 'react-router-dom';
import { fetchSearches } from 'v2/hooks/useFetchSearchesPaginated';
import { ReviewTabEnum } from 'v2/models';
import { REVIEW_STATUS } from 'v2/utils/searchUtils';
import { searchViewPath } from 'v2/utils/searchViewUtils';

const ForReviewRedirect = () => {
  const history = useHistory();

  useQuery(
    ['get_requests_under_review'],
    async () =>
      fetchSearches({
        size: 1,
        active: true,
        review_status__ne: REVIEW_STATUS.APPROVED,
      }),
    {
      onSuccess: (data) => {
        const route = data.count
          ? searchViewPath.forReview
          : searchViewPath.allSearches;
        const tab = data.count ? '/' + ReviewTabEnum.needs_review : '';
        history.push(`${route}${tab}/1`);
      },
      onError: () => {
        history.push(`${searchViewPath.allSearches}/1`);
      },
    }
  );

  return null;
};

export default ForReviewRedirect;
